import {Component, Input, OnInit} from '@angular/core';
import {CandidatureFormation} from '../../candidature-formation.model';
import {FormationService} from '../../../formation/formation.service';
import {Response} from '@angular/http';
import {Formation} from '../../../formation/formation.model';
import {ParametrageService} from '../../../parametrage/parametrage.service';
import {CONSTANTS} from '../../../../cadens.constants';
import {Question} from '../../../formation/question.model';
import {FormationComponentService} from '../formationComponent.service';


@Component({
    selector: 'jhi-autres-formations-component',
    templateUrl: 'autres-formations.component.html'
})
export class AutresFormationsComponent implements OnInit {

    @Input() candidatureFormation: CandidatureFormation = {};
    @Input() isEditable: Boolean;
    @Input() isBO: number;
    @Input() questions: Question[];
    @Input() currentLang: string;

    autresListe: Formation[];
    libelle = [];
    isLoading = true;
    parametrage: any;
    public constantes  = CONSTANTS ;

    constructor(private parametrageService: ParametrageService, private formationService: FormationService,
                private formationComponentService: FormationComponentService
    ) {
    }

    ngOnInit() {
        this.parametrageService.query({ page: CONSTANTS.AUTRES}).subscribe(
            (res: Response) => {
                let parametrage = res.json();
                parametrage.forEach(form => {
                    let code = form.code.replace('_INFORMATIONS', '');
                    this.libelle[code] = form.libelle;
                });
                this.isLoading = false;
            });
        this.parametrageService.query({ page: CONSTANTS.INTERNATIONAL}).subscribe(
            (res: Response) => {
                this.parametrage = this.parametrageService.parametresArrayToObject(res.json());
            });
        this.getListeAutresFormations();
    }

    changeFormation(formationId, libelle) {
        this.candidatureFormation.libelle = libelle;
        this.formationComponentService.changeFormation(formationId);
    }

    private getListeAutresFormations() {
        this.formationService.queryAutresFormations({ reinscription: this.candidatureFormation.reinscription,
            lecture: (this.isBO > 0 || !this.isEditable)}).subscribe(
            (res: Response) => {
                this.autresListe = res.json();
            });
    }


}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/candidature/formation/autres-formations/autres-formations.component.ts